
import { motion } from "framer-motion";

const DeleteAddressPopup = ({
    onConfirmDelete,
    onClose
}) => {
    return (
        <motion.div
        className="confirm-popup"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 50 }}
      >
        <h3>Are you sure you want to delete this address?</h3>
        <div className="confirm-popup-buttons">
          <button
            className="confirm-btn"
            onClick={onConfirmDelete} // Confirm delete
          >
            Yes, Delete
          </button>
          <button
            className="cancel-btn"
            onClick={onClose} // Close the popup without deleting
          >
            Cancel
          </button>
        </div>
      </motion.div>
    )
}

export default DeleteAddressPopup;